module.exports = __webpack_public_path__ + "static/media/mobile-menu.591c8ced.svg";